import PropTypes from 'prop-types';
import buyCertificationLink from '@/domain/buyCertificationLink';

export default function CertificationBuyLink({
  productId,
}) {
  return (
    <a
      className="text-center w-full flex items-center justify-center bg-green-500 text-white border border-transparent px-4 py-2 leading-5 rounded-full focus:ring-4 ring-transparent hover:bg-green-600 focus:outline-none focus:bg-green-600 focus:ring-green-200 space-x-2 font-medium transition ease-linear duration-100"
      href={buyCertificationLink(productId)}
      target="_blank"
      rel="noopener noreferrer"
    > 
      Comprar certificación
    </a>
  );
}

CertificationBuyLink.defaultProps = {};

CertificationBuyLink.propTypes = {
  productId: PropTypes.number.isRequired,
};
